import React from 'react';
import './Welcome.css';
import Header from "../Header";
import {Link} from "react-router-dom";
import logo_SONDAGE from "../../assets/SONDAGE.svg";
import logo_RECLAMATION from "../../assets/RECLAMATION.svg";
import logo_RightCom from "../../assets/logo.svg";

const Welcome = (props) => {
    return (
        <div>
            <Header company={props.company} companyData={props.companyData} isHome={true}/>
            <div>
                <div className="right-tmb-container">
                    <div className="right-tmb-header">
                        <div className="title">
                            Sélectionnez une option
                        </div>
                    </div>
                    <div className="right-tmb-content">
                        <div>
                            {props.formData.survey_link && <Link to="/survey">
                                <div className="right-tmb-product" style={{
                                    background: props.formData?.background_color || 'grey',
                                    color: props.formData?.text_color || 'grey'
                                }}>
                                    <div className="content">
                                        <div className="right-tmb-product-container">
                                            <img className="icon" src={logo_SONDAGE} alt="sondage"/>
                                            <span className="title">SONDAGE</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>}

                            {props.formData.support_link && <Link to="/bot">
                                <div className="right-tmb-product" style={{
                                    background: props.formData?.background_color || 'grey',
                                    color: props.formData?.text_color || 'grey'
                                }}>
                                    <div className="content">
                                        <div className="right-tmb-product-container">
                                            <img className="icon" src={logo_RECLAMATION} alt="reclamation"/>
                                            <span className="title">SERVICE CLIENT</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>}
                            {!props.formData.survey_link && !props.formData.support_link && <div>
                                <p>Please Setup your menu via the mobile app.</p>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="right-tmb-footer-wrap">
                    <span className="title">A product of</span>
                    <img className="logo" src={logo_RightCom} alt="logo"/>
                </div>
            </div>
        </div>
    );
};

export default Welcome;